import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from '@/modules/auth';
import medicalCondition from '@/modules/medicalCondition';
import media from '@/modules/media';
import mediaTag from '@/modules/mediaTag';
import redeemable from '@/modules/redeemable';
import reward from '@/modules/reward';
import rewardTemplate from '@/modules/rewardTemplate';
import scalpCondition from '@/modules/scalpCondition';
import shop from '@/modules/shop';
import statistic from '@/modules/statistic';
import user from '@/modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    medicalCondition,
    media,
    mediaTag,
    redeemable,
    reward,
    rewardTemplate,
    scalpCondition,
    shop,
    statistic,
    user,
  },
  plugins: [
    createPersistedState({
      paths: ['auth'],
    }),
  ],
});
